import { Switch } from "@headlessui/react";
import React from "react";
import { CiSquareCheck } from "react-icons/ci";
import { FaRegWindowClose } from "react-icons/fa";
import { IoIosStar } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import { toast } from "react-toastify";
import { getApiCaller } from "../../libs/apiCaller";

const Provider = ({ isLoading, providers, setProviders, fetchProviders }) => {
  const navigate = useNavigate();

  const toggleProviderStatus = async (provider) => {
    const newStatus = provider.provider_status === "enable" ? 2 : 1; // 1 = enable, 2 = disable
    const updatedProviders = providers.map((p) =>
      p.id === provider.id
        ? { ...p, provider_status: newStatus === 1 ? "enable" : "disable" }
        : p
    );

    try {
      await getApiCaller(
        `provider_status_change?provider_id=${provider.id}&status=${newStatus}`
      );
      setProviders(updatedProviders); // Update state to reflect change
      toast.success(
        `Provider ${newStatus === 1 ? "enabled" : "disabled"} successfully!`
      );
      fetchProviders && fetchProviders();
    } catch (error) {
      toast.error("Failed to update provider status.");
    }
  };

  return (
    <>
      <div className="overflow-x-auto">
        <table className="w-full border border-1 rounded-xl min-w-[800px]">
          <thead className="bg-gray-50 rounded-t-xl">
            <tr>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                No.
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Provider Name
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Availability
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Appointments Completed
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Appointments Cancelled
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Joined Date
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Appointment Fee
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Rating
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Disable Provider
              </th>
              <th className="py-3 px-4 text-left text-sm tracking-wide text-[#60646C]">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="10" className="pt-5 pb-7 justify-items-center">
                  <PropagateLoader color="#284184" loading={true} size={10} />
                </td>
              </tr>
            ) : providers?.length === 0 ? (
              <tr>
                <td
                  colSpan="10"
                  className="pt-5 pb-7 justify-items-center text-center"
                >
                  No Providers Found...
                </td>
              </tr>
            ) : (
              providers.map((provider, index) => (
                <tr key={provider.id} className="border-b hover:bg-gray-50">
                  <td className="py-4 px-4 text-base">{index + 1}</td>
                  <td className="py-4 px-4 text-base">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                        <img
                          src={
                            provider.profile_picture ||
                            "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqafzhnwwYzuOTjTlaYMeQ7hxQLy_Wq8dnQg&s"
                          }
                          alt={provider.first_name}
                          className="w-10 h-10 rounded-full"
                        />
                      </div>
                      {provider.first_name} {provider.last_name}
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    {provider.availability ? (
                      <CiSquareCheck className="text-[#00A651] text-2xl" />
                    ) : (
                      <FaRegWindowClose className="text-[#F04438] text-base" />
                    )}
                  </td>
                  <td className="py-4 px-4 text-base">
                    {provider.complete_appointment}
                  </td>
                  <td className="py-4 px-4 text-base">
                    {provider.canceled_appointment}
                  </td>
                  <td className="py-4 px-4 text-base">
                    {provider.joined_date}
                  </td>
                  <td className="py-4 px-4 text-base">
                    ${provider.appointment_fee}
                  </td>
                  <td className="py-4 px-4 text-base">
                    <div className="flex items-center gap-2">
                      <IoIosStar />
                      {provider.rating}
                    </div>
                  </td>
                  <td className="py-4 px-4">
                    <Switch
                      checked={provider.provider_status === "enable"}
                      onChange={() => toggleProviderStatus(provider)}
                      className={`group inline-flex h-6 w-11 items-center rounded-full transition ${
                        provider.provider_status !== "enable"
                          ? "bg-[#284184]"
                          : "bg-gray-200"
                      }`}
                    >
                      <span
                        className={`size-4 translate-x-1 rounded-full bg-white transition ${
                          provider.provider_status !== "enable"
                            ? "translate-x-6"
                            : ""
                        }`}
                      />
                    </Switch>
                  </td>
                  <td className="py-4 px-4">
                    <button
                      className="text-base text-[#284184] underline"
                      onClick={() =>
                        navigate("/providerProfile", { state: { provider } })
                      }
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Provider;
